
import { defineComponent, PropType } from 'vue'
import { iLayer } from '../LayersManagement.d'
import { AxiosResponse } from 'axios'
import { downloadDirect } from '@/helpers/commons/fileHelper'
import Dialog from 'primevue/dialog'
import layersManagementDownloadDialogDescriptor from './LayersManagementDownloadDialogDescriptor.json'
import RadioButton from 'primevue/radiobutton'

export default defineComponent({
    name: 'qbe-join-definition-dialog',
    components: { Dialog, RadioButton },
    props: { visible: { type: Boolean }, layer: { type: Object as PropType<iLayer>, required: true } },
    emits: ['close'],
    data() {
        return {
            layersManagementDownloadDialogDescriptor,
            downloadMode: 'geojson'
        }
    },
    computed: {
        modes(): string[] {
            return this.layer.type === 'WFS' ? this.layersManagementDownloadDialogDescriptor.downloadModesWFS : this.layersManagementDownloadDialogDescriptor.downloadModes
        }
    },
    created() {},
    methods: {
        closeDialog() {
            this.$emit('close')
        },
        async download() {
            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `layers/getDownload?id=${this.layer.layerId}%2CtypeWFS=${this.downloadMode}`, { headers: { Accept: 'application/json, text/plain, */*' } })
                .then((response: AxiosResponse<any>) => {
                    if (this.downloadMode === 'geojson') {
                        downloadDirect(JSON.stringify(response.data), this.layer.name, 'application/json')
                    } else {
                        window.open(response.data.url)
                    }
                    this.$emit('close')
                })
                .catch(() => {})
        }
    }
})
